import React, { useEffect, useState } from "react";
import { ClockIcon } from "lucide-react";
const START_SECONDS = 17 * 60 + 34;
type CountdownProps = {
  tone?: "light" | "dark";
};
export function Countdown({
  tone = "light"
}: CountdownProps) {
  const [left, setLeft] = useState(START_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setLeft(prev => prev <= 1 ? START_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const parts = [{
    label: "Hours",
    value: Math.floor(left / 3600)
  }, {
    label: "Minutes",
    value: Math.floor(left % 3600 / 60)
  }, {
    label: "Seconds",
    value: left % 60
  }];
  const labelColor = tone === "dark" ? "text-cyan" : "text-navy";
  const sepColor = tone === "dark" ? "text-white" : "text-navy";
  const boxColor = tone === "dark" ? "bg-white text-navy" : "bg-navy text-white";
  return <div className="mt-6 flex flex-col items-center" role="timer" aria-live="off" data-id="element-310" data-mp="34tvf1vkz9mfv">
      <p className={`flex items-center gap-2 text-xs font-bold uppercase tracking-widest ${labelColor}`} data-id="element-311" data-mp="2c7njobts2d1j">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-312" data-mp="2h6qg57vozaxw" />
        The special offer ends in:
      </p>
      <div className="mt-3 flex items-start gap-2" data-id="element-313" data-mp="2l8leq4m8na7z">
        {parts.map((p, i) => <React.Fragment key={p.label} data-id="element-314" data-mp="2q7g5ptud0536" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-315" data-mp="2q6dhxusc2irh">
              <span className={`flex h-16 w-16 items-center justify-center rounded-xl font-display text-4xl font-bold tabular-nums sm:h-20 sm:w-20 sm:text-5xl ${boxColor}`} data-id="element-316" data-mp="1th5ugh85lzkx">
                {String(p.value).padStart(2, "0")}
              </span>
              <span className={`mt-1.5 text-[11px] font-semibold uppercase tracking-wider ${tone === "dark" ? "text-white/70" : "text-muted"}`} data-id="element-317" data-mp="22fr8bz2okqfd">
                {p.label}
              </span>
            </div>
            {i < parts.length - 1 && <span className={`pt-3 font-display text-3xl font-bold sm:pt-4 ${sepColor}`} aria-hidden="true" data-id="element-318" data-mp="1erhrzco8kuvm">
                :
              </span>}
          </React.Fragment>)}
      </div>
    </div>;
}